import { Component, Input } from '@angular/core';
import { IconSize, TopBarPadding } from '../../../widget-editors/top-bar/top-bar.model';
import { TopBarSettings } from '../widget-preview.types';

const ICON_SIZE_PX: Record<IconSize, number> = { small: 16, medium: 20, large: 24 };
// Mirrors the storefront: Padding drives the vertical only, the horizontal stays on the drawer's
// shared gutter so the title keeps lining up with the widgets below it.
const PADDING_Y_PX: Record<TopBarPadding, number> = { none: 0, small: 8, medium: 16, large: 24 };
const DEFAULT_PADDING: TopBarPadding = 'medium';
const PADDING_X_PX = 20;

@Component({
  selector: 'top-bar-preview',
  templateUrl: './top-bar-preview.component.html',
  styleUrls: ['./top-bar-preview.component.scss'],
  standalone: false,
})
export class TopBarPreviewComponent {
  @Input() settings!: TopBarSettings;
  @Input() itemCount = 3;

  get containerStyle(): Record<string, string> {
    const border = this.settings.bottomBorder.enabled ? `1px solid ${this.settings.bottomBorder.color}` : 'none';
    const paddingY = PADDING_Y_PX[this.settings.padding ?? DEFAULT_PADDING] ?? PADDING_Y_PX[DEFAULT_PADDING];
    return {
      display: 'flex',
      'justify-content': 'space-between',
      'align-items': 'center',
      padding: `${paddingY}px ${PADDING_X_PX}px`,
      'background-color': this.settings.backgroundColor,
      'border-bottom': border,
    };
  }

  // Only set when the merchant picked one, so an unset title keeps inheriting — same rule as the
  // storefront's titleStyle.
  get titleColor(): string {
    return this.settings.title.textColor ?? '';
  }

  get closeButtonStyle(): Record<string, string> {
    const iconPx = ICON_SIZE_PX[this.settings.closeButton.iconSize];
    return {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      width: `${iconPx + 16}px`,
      height: `${iconPx + 16}px`,
      'font-size': `${iconPx + 8}px`,
      color: this.settings.closeButton.iconColor,
      'background-color': this.settings.closeButton.backgroundColor,
      border: 'none',
      'border-radius': '4px',
      cursor: 'default',
      padding: '0',
      transition: 'background-color 0.2s',
    };
  }

  get renderedTitleHtml(): string {
    const text = this.settings.title.text ?? '';
    return text.replace(/\{item_count\}/g, String(this.itemCount));
  }

  onCloseHoverEnter(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).style.backgroundColor = this.settings.closeButton.hoverColor;
  }

  onCloseHoverLeave(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).style.backgroundColor = this.settings.closeButton.backgroundColor;
  }
}
